import React, { Suspense, lazy } from "react";
import { Redirect, Switch, Route } from "react-router-dom";
import { LayoutSplashScreen, ContentRoute } from "../_themeBase/layout";
import { DormitoryDashboard } from "../_themeBase/_partials/dashboards/DormitoryDashboard";
import UserProfilePage from "./modules/UserProfile/UserProfilePage";
import DashboardPage from "./pages/DashboardPage";
import { useSelector } from "react-redux";

// const DashboardPage = lazy(() =>
//   import("./pages/DashboardPage")
// );
const DormBasePage = lazy(() =>
  import("./modules/BaseInfo/dorms/DormBasePage")
);
const CollageBasePage = lazy(() =>
  import("./modules/BaseInfo/collages/CollageBasePage")
);
const GroupBasePage = lazy(() =>
  import("./modules/BaseInfo/groups/GroupBasePage")
);
const DevicePage = lazy(() => import("./modules/BaseInfo/devices/DevicePage"));
const TermBasePage = lazy(() =>
  import("./modules/BaseInfo/terms/TermBasePage")
);
const UniInfoPage = lazy(() =>
  import("./modules/BaseInfo/UniInfo/UniInfoPage")
);
const RolePage = lazy(() => import("./modules/BaseInfo/permissions/RolePage"));
const GradePage = lazy(() => import("./modules/BaseInfo/grades/GradePage"));
const AccountPage = lazy(() =>
  import("./modules/BaseInfo/accounts/AccountPage")
);
const UsersPage = lazy(() => import("./modules/BaseInfo/user/UsersPage"));
const CalendarBasePage = lazy(() =>
  import("./modules/BaseInfo/yearCalendar/CalendarBasePage")
);
const WorkUnitPage = lazy(() =>
  import("./modules/BaseInfo/workUnit/WorkUnitPage")
);
const BlogPage = lazy(() => import("./modules/BaseInfo/blogs/BlogPage"));
const LogPage = lazy(() => import("./modules/BaseInfo/logs/LogPage"));

const EmsSettingPage = lazy(() =>
  import("./modules/BaseInfo/emsSetting/EmsSettingPage")
);

const ProvinceBasePage = lazy(() =>
  import("./modules/BaseInfo/proviences/ProvinceBasePage")
);

const ShiftBasePage = lazy(() =>
  import("./modules/Attendence/shifts/ShiftBasePage")
);
const DailyMissionPage = lazy(() =>
  import("./modules/Attendence/missions/DailyMissionPage")
);
const UserTrafficPage = lazy(() =>
  import("./modules/Attendence/userTraffic/UserTrafficPage")
);
const TrafficReportBasePage = lazy(() =>
  import("./modules/Attendence/trafficReport/TrafficReportBasePage")
);
const MyTrafficPage = lazy(() =>
  import("./modules/Attendence/userTraffic/MyTrafficPage")
);
const MyDailyMissionPage = lazy(() =>
  import("./modules/Attendence/missions/MyDailyMissionPage")
);
const MyTrafficReportBasePage = lazy(() =>
  import("./modules/Attendence/trafficReport/MyTrafficReportBasePage")
);

const CorrespondenceCategoryPage = lazy(() =>
  import("./modules/BaseInfo/correspondence/CorrespondenceCategoryPage")
);
const CorrespondencePage = lazy(() =>
  import("./modules/BaseInfo/correspondence/CorrespondencePage")
);

const RankingSettingPage = lazy(() =>
  import("./modules/BaseInfo/rankingSetting/RankingSettingPage")
);

const SalonPage = lazy(() => import("./modules/Sport/Salon/SalonPage"));
const SportPage = lazy(() => import("./modules/Sport/Sport/SportPage"));
const ClosetPage = lazy(() => import("./modules/Sport/Closet/ClosetPage"));
const ContractPage = lazy(() =>
  import("./modules/Sport/Contract/ContractPage")
);
const SansCategoryPage = lazy(() =>
  import("./modules/Sport/Sans/SansCategoryPage")
);
const SportAddCreditPage = lazy(() =>
  import("./modules/Sport/EPay/SportAddCreditPage")
);
//const PaymentResultPage = lazy(() => import("./modules/Sport/EPay/PaymentResultPage"));
const SportUsersReportPage = lazy(() =>
  import("./modules/Sport/reports/SportUsersReportPage")
);
const SportlReservationPage = lazy(() =>
  import("./modules/Sport/sportReservation/SportlReservationPage")
);
const ManageSportReservationPage = lazy(() =>
  import("./modules/Sport/sportReservation/ManageSportReservationPage")
);
const MySportReservationPage = lazy(() =>
  import("./modules/Sport/sportReservation/MySportReservationPage")
);

const DormTrafficReportPage = lazy(() =>
  import("./modules/Dorm/dormTrafficReport/DormTrafficReportPage")
);
const MyDormTrafficReportPage = lazy(() =>
  import("./modules/Dorm/dormTrafficReport/MyDormTrafficReportPage")
);
const DormitoryTrafficPage = lazy(() =>
  import("./modules/Dorm/dormTraffic/DormitoryTrafficPage")
);
const MyDormitoryTrafficPage = lazy(() =>
  import("./modules/Dorm/dormTraffic/MyDormitoryTrafficPage")
);
const ReservationTimeSettingPage = lazy(() =>
  import("./modules/Dorm/reservationTimeSetting/ReservationTimeSettingPage")
);
const DormTermPage = lazy(() => import("./modules/Dorm/dormTerm/DormTermPage"));
const RoomPricingPage = lazy(() =>
  import("./modules/Dorm/roomPricing/RoomPricingPage")
);
const RoomReservationPage = lazy(() =>
  import("./modules/Dorm/roomReservation/RoomReservationPage")
);
const ManageRoomReservationPage = lazy(() =>
  import("./modules/Dorm/roomReservation/ManageRoomReservationPage")
);
const MyRoomReservationPage = lazy(() =>
  import("./modules/Dorm/roomReservation/MyRoomReservationPage")
);
const RoomReservationReportPage = lazy(() =>
  import("./modules/Dorm/roomReseervationReport/RoomReservationReportPage")
);
const DormPersonReportPage = lazy(() =>
  import("./modules/Dorm/generalReports/personReport/DormPersonReportPage")
);
const DormFinanciaReportPage = lazy(() =>
  import("./modules/Dorm/generalReports/financiaReport/DormFinanciaReportPage")
);
const RoomStatusPage = lazy(() =>
  import("./modules/Dorm/roomStatus/RoomStatusPage")
);
const DormRequestPage = lazy(() =>
  import("./modules/Dorm/dormRequest/DormRequestPage")
);
const AcceptDormRulesPage = lazy(() =>
  import("./modules/Dorm/dormRequest/AcceptDormRulesPage")
);
const DormitorySmsBasePage = lazy(() =>
  import("./modules/Dorm/dormSms/DormitorySmsBasePage")
);

export default function BasePage() {
  // Pick the first accessible menu item (ignore tab menus and items without URL)
  const menuFromStore = useSelector((state) => state?.auth?.menu);
  // از مسیرهای منو همان‌گونه که سرور ارسال می‌کند استفاده می‌کنیم
  // گرفتن اولین آیتم مجاز هر سامانه (isTabMenu=true) که url معتبر دارد و بر اساس orderInTab مرتب شده
  const getFirstAccessibleMenuUrl = (menu, tabId = null) => {
    if (!Array.isArray(menu)) return null;
    // اگر tabId داده شده، فقط آیتم‌های زیرمجموعه آن سامانه را بررسی کن
    let items = menu.filter(
      (m) => !m.isTabMenu && m.url && m.url !== "NULL" && m.isMenu && (tabId != null ? m.tabId === tabId : true)
    );
    // مرتب‌سازی بر اساس orderInTab
    items = items.sort((a, b) => (a.orderInTab || 0) - (b.orderInTab || 0));
    return items.length > 0 ? items[0].url : null;
  };
  
  // گرفتن اولین آیتم از اولین سامانه (برای صفحه اول بعد از لاگین)
  const getFirstAccessibleMenuFromFirstTab = (menu) => {
    if (!Array.isArray(menu)) return null;
    // پیدا کردن اولین سامانه بر اساس orderInTab
    const tabs = menu.filter((m) => m.isTabMenu && m.isMenu)
                     .sort((a, b) => (a.orderInTab || 0) - (b.orderInTab || 0));
    if (tabs.length === 0) return null;
    
    // گرفتن اولین آیتم مجاز از اولین سامانه
    return getFirstAccessibleMenuUrl(menu, tabs[0].id);
  };
  // گرفتن لیست سامانه‌ها (isTabMenu=true)
  const getTabMenus = (menu) => Array.isArray(menu) ? menu.filter((m) => m.isTabMenu) : [];
  const menuFromSession = (() => {
    try {
      const raw = sessionStorage.getItem("authUserMenu");
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  })();
  // مسیرهای fallback برای سامانه‌های شناخته‌شده تا قبل از لود منو هم 404 نشود
  const findTabIdByUrl = (menu, tabBaseUrl) => {
    if (!Array.isArray(menu)) return null;
    const tab = menu.find((m) => m.isTabMenu && m.url === tabBaseUrl);
    return tab ? tab.id : null;
  };
  const firstFromTabBase = (tabBaseUrl) => {
    const tabId = findTabIdByUrl(menuFromStore, tabBaseUrl) || findTabIdByUrl(menuFromSession, tabBaseUrl);
    if (!tabId) return null;
    return getFirstAccessibleMenuUrl(menuFromStore, tabId) || getFirstAccessibleMenuUrl(menuFromSession, tabId);
  };

  const defaultRootUrl =
    getFirstAccessibleMenuFromFirstTab(menuFromStore) ||
    getFirstAccessibleMenuFromFirstTab(menuFromSession) ||
    // تلاش برای انتخاب از تب‌های شناخته‌شده
    (firstFromTabBase("/dorm") || firstFromTabBase("/attendance") || firstFromTabBase("/sport")) ||
    "/persons"; // fallback نهایی

  // ساخت ریدایرکت داینامیک برای هر سامانه
  const tabMenusFromStore = getTabMenus(menuFromStore);
  const tabMenusFromSession = getTabMenus(menuFromSession);
  const tabMenus = (tabMenusFromStore && tabMenusFromStore.length > 0) ? tabMenusFromStore : tabMenusFromSession;
  const tabRedirects = (tabMenus || []).map((tab) => {
    const firstUrl = getFirstAccessibleMenuUrl(menuFromStore, tab.id) || getFirstAccessibleMenuUrl(menuFromSession, tab.id);
    if (firstUrl && tab.url) {
      return (
        <Route
          key={tab.url}
          exact
          path={tab.url}
          render={() => <Redirect to={firstUrl} />}
        />
      );
    }
    return null;
  });
  return (
    <Suspense fallback={null}>
      <Switch>
        <Route exact path="/" render={() => <Redirect to={defaultRootUrl} />} />
        {/* Fallback های اولیه برای مسیرهای سطح سامانه */}
        <Route exact path="/dorm" render={() => <Redirect to={firstFromTabBase("/dorm") || "/dorm/dormDashboard"} />} />
        <Route exact path="/sport" render={() => <Redirect to={firstFromTabBase("/sport") || "/sport/myReservation"} />} />
        <Route exact path="/attendance" render={() => <Redirect to={firstFromTabBase("/attendance") || "/traffics"} />} />

        {/* ریدایرکت داینامیک برای هر سامانه */}
        {tabRedirects}

        <ContentRoute path="/dashboard" component={DashboardPage} />
        <ContentRoute path="/terms" component={TermBasePage} />
        <ContentRoute path="/uni" component={UniInfoPage} />
        <ContentRoute path="/dorms" component={DormBasePage} />
        <ContentRoute path="/collages" component={CollageBasePage} />
        <ContentRoute path="/groups" component={GroupBasePage} />
        <ContentRoute path="/devices" component={DevicePage} />
        <ContentRoute path="/grades" component={GradePage} />
        <ContentRoute path="/accounts" component={AccountPage} />
        <ContentRoute path="/calendar" component={CalendarBasePage} />
        <ContentRoute path="/permissions" component={RolePage} />
        <ContentRoute path="/persons" component={UsersPage} />
        <ContentRoute path="/workunit" component={WorkUnitPage} />
        <ContentRoute path="/blogs" component={BlogPage} />
        <ContentRoute path="/logs" component={LogPage} />
        <ContentRoute path="/emsSetting" component={EmsSettingPage} />
        <ContentRoute path="/provinces" component={ProvinceBasePage} />
        {/* <ContentRoute path="/user-profile" component={UserProfilePage} /> */}
        <ContentRoute
          path="/categoryCorrespondence"
          component={CorrespondenceCategoryPage}
        />
        <ContentRoute path="/correspondence" component={CorrespondencePage} />
        <ContentRoute path="/rankingSetting" component={RankingSettingPage} />

        <ContentRoute path="/shifts" component={ShiftBasePage} />
        <ContentRoute path="/dailyMission" component={DailyMissionPage} />
        <ContentRoute path="/myDailyMission" component={MyDailyMissionPage} />
        <ContentRoute path="/userTraffic" component={UserTrafficPage} />
        <ContentRoute path="/traffics" component={MyTrafficPage} />
        <ContentRoute path="/trafficReport" component={TrafficReportBasePage} />
        <ContentRoute
          path="/myTrafficReport"
          component={MyTrafficReportBasePage}
        />

        <ContentRoute
          path="/dorm/dormDashboard"
          component={DormitoryDashboard}
        />
        <ContentRoute
          path="/dorm/dormTrafficReport"
          component={DormTrafficReportPage}
        />
        <ContentRoute
          path="/dorm/myDormTrafficReport"
          component={MyDormTrafficReportPage}
        />
        <ContentRoute
          path="/dorm/dormUserTraffic"
          component={DormitoryTrafficPage}
        />
        <ContentRoute
          path="/dorm/myDormTraffics"
          component={MyDormitoryTrafficPage}
        />
        <ContentRoute
          path="/dorm/reservationTimeSetting"
          component={ReservationTimeSettingPage}
        />
        <ContentRoute path="/dorm/dormTermSetting" component={DormTermPage} />
        <ContentRoute path="/dorm/roomPricing" component={RoomPricingPage} />
        <ContentRoute
          path="/dorm/roomReservation"
          component={RoomReservationPage}
        />
        <ContentRoute
          path="/dorm/manageReservation"
          component={ManageRoomReservationPage}
        />
        <ContentRoute
          path="/dorm/myReservation"
          component={MyRoomReservationPage}
        />
        <ContentRoute
          path="/dorm/dormReservationReport"
          component={RoomReservationReportPage}
        />
        <ContentRoute
          path="/dorm/dormPersonReport"
          component={DormPersonReportPage}
        />
        <ContentRoute
          path="/dorm/dormFinanciaReport"
          component={DormFinanciaReportPage}
        />
        <ContentRoute path="/dorm/statusRoom" component={RoomStatusPage} />
        <ContentRoute
          path="/dorm/preRegisterForm"
          component={DormRequestPage}
        />
        <ContentRoute
          path="/dorm/reqPreRegister"
          component={AcceptDormRulesPage}
        />
        <ContentRoute
          path="/dorm/dormitorySms"
          component={DormitorySmsBasePage}
        />

        <ContentRoute path="/sport/salon" component={SalonPage} />
        <ContentRoute path="/sport/sport" component={SportPage} />
        <ContentRoute path="/sport/closet" component={ClosetPage} />
        <ContentRoute path="/sport/contract" component={ContractPage} />
        <ContentRoute path="/sport/sans" component={SansCategoryPage} />
        <ContentRoute path="/sport/credit" component={SportAddCreditPage} />
        <ContentRoute path="/sport/report" component={SportUsersReportPage} />
        <ContentRoute
          path="/sport/reservation"
          component={SportlReservationPage}
        />
        <ContentRoute
          path="/sport/manageReservation"
          component={ManageSportReservationPage}
        />
        <ContentRoute
          path="/sport/myReservation"
          component={MySportReservationPage}
        />
        {/* <ContentRoute
          path="/sport/credit/payment/:id"
          component={PaymentResultPage}
        /> */}

        <ContentRoute path="/user-profile" component={UserProfilePage} />

        <Redirect to="error/error-v1" />
      </Switch>
    </Suspense>
  );
}
